export const bookmarksModalParams = {
  height: 'auto',
  maxHeight: '100%',
  backdropClass: 'bookmarks-modal-backdrop',
  panelClass: 'bookmarks-modal-panel',
  width: '45rem',
  maxWidth: '100%',
  autoFocus: true,
  overflow: 'auto'
};
